import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './rootPlacesQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type RootPlacesQuery_rootPlaces_RootPlacePaginationHandler_records_RootPlace = {
  __typename: 'RootPlace',
  id: number,
  feedTitle: string,
  name: string,
  slug: string
};

export type RootPlacesQuery_rootPlaces_RootPlacePaginationHandler = {
  __typename: 'RootPlacePaginationHandler',
  records: Array<RootPlacesQuery_rootPlaces_RootPlacePaginationHandler_records_RootPlace>
};

export type RootPlacesQuery_Query = {
  __typename?: 'Query',
  rootPlaces: RootPlacesQuery_rootPlaces_RootPlacePaginationHandler
};


export type RootPlacesQueryVariables = Types.Exact<{
  isFeatured: Types.Scalars['Boolean']['input'];
}>;


export type RootPlacesQuery = RootPlacesQuery_Query;


export const RootPlacesDocument = /*#__PURE__*/ document as unknown as DocumentNode<RootPlacesQuery, RootPlacesQueryVariables>;


/**
 * __useRootPlacesQuery__
 *
 * To run a query within a React component, call `useRootPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootPlacesQuery({
 *   variables: {
 *      isFeatured: // value for 'isFeatured'
 *   },
 * });
 */
export function useRootPlacesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RootPlacesQuery, RootPlacesQueryVariables> & ({ variables: RootPlacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RootPlacesQuery, RootPlacesQueryVariables>(RootPlacesDocument, options);
      }
export function useRootPlacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RootPlacesQuery, RootPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RootPlacesQuery, RootPlacesQueryVariables>(RootPlacesDocument, options);
        }
// @ts-ignore
export function useRootPlacesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RootPlacesQuery, RootPlacesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlacesQuery, RootPlacesQueryVariables>;
export function useRootPlacesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlacesQuery, RootPlacesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RootPlacesQuery | undefined, RootPlacesQueryVariables>;
export function useRootPlacesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RootPlacesQuery, RootPlacesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RootPlacesQuery, RootPlacesQueryVariables>(RootPlacesDocument, options);
        }
export type RootPlacesQueryHookResult = ReturnType<typeof useRootPlacesQuery>;
export type RootPlacesLazyQueryHookResult = ReturnType<typeof useRootPlacesLazyQuery>;
export type RootPlacesSuspenseQueryHookResult = ReturnType<typeof useRootPlacesSuspenseQuery>;
export type RootPlacesQueryResult = ApolloReactCommon.QueryResult<RootPlacesQuery, RootPlacesQueryVariables>;